import { render, staticRenderFns } from "./MaterialManagement.vue?vue&type=template&id=3f9ee34c&scoped=true"
import script from "./MaterialManagement.vue?vue&type=script&lang=js"
export * from "./MaterialManagement.vue?vue&type=script&lang=js"
import style0 from "./MaterialManagement.vue?vue&type=style&index=0&id=3f9ee34c&prod&lang=scss"
import style1 from "./MaterialManagement.vue?vue&type=style&index=1&id=3f9ee34c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9ee34c",
  null
  
)

export default component.exports